import { CENTER_CANVAS_DEFAULTS } from '../constants/center-canvas-defaults'
import type { CenterCanvasConfig } from '../types/center-canvas-config'
import type { ResolvedCenterCanvasConfig } from '../types/resolved-center-canvas-config'

/**
 * Fills in `CenterCanvas`'s prop defaults. A default applies only when the prop is `undefined` —
 * a `null` passes through — matching the destructuring defaults this replaces.
 */
export function applyCenterCanvasDefaults(props: CenterCanvasConfig): ResolvedCenterCanvasConfig {
  const resolved: Record<string, unknown> = { ...props }

  for (const [key, value] of Object.entries(CENTER_CANVAS_DEFAULTS)) {
    if (resolved[key] === undefined) resolved[key] = value
  }

  // A fresh array per render, as the inline `unifiedLayerIds = []` default gave:
  // `useLayerArrangeGates` syncs its ref in an effect keyed on this array's identity.
  if (resolved.unifiedLayerIds === undefined) resolved.unifiedLayerIds = []

  return resolved as ResolvedCenterCanvasConfig
}
